module.exports = __webpack_public_path__ + "static/NCPA-logo-b7d907c6671484bb930caf2bd8947e31.png";